import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync, FilterCheckBox } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { mappedProductTypes } from '../../enums/ProductTypes';
import {
  DisplayCurrencyAmount,
  DisplayGuid,
  DisplayType,
  DisplayBoolean
} from '../items';

const resultsCount = 15;

class ProductsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { products: { searchProduct } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchProduct({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, api } = this.props;
    const {
      providers: { lookupByNameOrId: lookupProvider },
      facilities: { lookupByNameOrId: lookupFacility },
    } = api;

    const { categories } = this.props;  
    const mappedCategories = categories.map(({ Name }) => ({ value: Name, label: Name }));

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Products page'
              documentDescription='Products page'
            />

            <h2 className='main-page-header'>
              Products
              <span className={"add-entity-button"} onClick={() => { history.push('/product/new'); }}  />
            </h2>

            <Filters
              initFromUrl
              submitUrl
              defaultValue={{
                isVisible: 'true'
              }}
              validateForm={({
                productId,
                name,
                type,
                category,
                afterAt,
                beforeAt,
                providerId,
                facilityId,
                groupId,
                isVisible
              }, updatedKey) => {
                if (updatedKey !== 'productId') {
                  return {
                    productId,
                    name,
                    type,
                    category,
                    afterAt,
                    beforeAt,
                    providerId,
                    facilityId,
                    groupId,
                    isVisible
                  };
                }
                return { productId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='productId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='productId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='name'>
                      Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='name'
                      placeholder='Filter by name'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='type'>
                      Type
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='type'
                      options={mappedProductTypes}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='category'>
                      Category
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='category'
                      options={mappedCategories}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='providerId'>
                      Provider
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='providerId'
                      loadOptions={async inputValue => lookupProvider(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='facilityId'
                      loadOptions={async inputValue => lookupFacility(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='isVisible'>
                      Is Visible
                    </label>
                    <FilterCheckBox
                      data={formData}
                      debounce
                      update={update}
                      name='isVisible'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />

            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'products',
                rowClasses: 'hover-listview ',
                rowClick: ({ Id, Type }) => {
                  history.push(`/product/details/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Name',
                    label: 'Name'
                  }, {
                    property: 'Type',
                    label: 'Type',
                    render: ({ Type }) => <DisplayType>{Type}</DisplayType>
                  }, {
                    property: 'GroupName',
                    label: 'Group'
                  }, {
                    property: 'FacilityName',
                    label: 'Facility'
                  }, {
                    property: 'Category',
                    label: 'Category'
                  }, {
                    property: 'Amount',
                    label: 'Amount',
                    render: ({ Price, CurrencyIsoCode }) =>
                      <DisplayCurrencyAmount amount={Price} alignRight currency={CurrencyIsoCode} />
                  }, {
                    property: 'IsVisible',
                    label: 'Is Visible',
                    render: ({ IsVisible }) => <DisplayBoolean>{IsVisible}</DisplayBoolean>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);
                const { isVisible } = filters;

                // todo handle default values together with filter component
                filters.isVisible = isVisible === undefined || isVisible === null ? 'true' : isVisible;

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Products = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ProductsInternal)
));

Products.requiresLogin = true;
Products.propTypes = { isLoggedIn: PropTypes.bool };

export default Products;